import { render, staticRenderFns } from "./BlogFooterCarousel.vue?vue&type=template&id=ea392070&scoped=true&"
import script from "./BlogFooterCarousel.vue?vue&type=script&lang=js&"
export * from "./BlogFooterCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BlogFooterCarousel.vue?vue&type=style&index=0&id=ea392070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea392070",
  null
  
)

export default component.exports